import * as i0 from '@angular/core';
import { Injectable, Component, Input, NgModule } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';
import * as i1 from '@angular/common/http';
import * as i2 from '@angular/forms';
import { FormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import * as i3 from '@angular/common';
import { PrimengLibraryModule } from 'primeng-library';

class LibAssignMultipleJobIdService {
    constructor(http) {
        this.http = http;
        this.onLoadResponseSubject = new BehaviorSubject(null);
    }
    getJobIdList() {
        return this.http.get(`/vd/dataSource/FB_HIRING_MDS_LISTOF_JOBIDS/elements`).pipe(map((response) => {
            if (response.status === 200) {
                this.onLoadResponseSubject.next(response);
                return response;
            }
            else {
                return null;
            }
        }));
    }
    getDetails(jobId) {
        return this.http.get(`/vd/formBuilder/get/postPosition/${jobId}/details`).pipe(map((response) => {
            if (response.status === 200) {
                this.onLoadResponseSubject.next(response);
                return response;
            }
            else {
                return null;
            }
        }));
    }
}
LibAssignMultipleJobIdService.ɵfac = function LibAssignMultipleJobIdService_Factory(t) { return new (t || LibAssignMultipleJobIdService)(i0.ɵɵinject(i1.HttpClient)); };
LibAssignMultipleJobIdService.ɵprov = i0.ɵɵdefineInjectable({ token: LibAssignMultipleJobIdService, factory: LibAssignMultipleJobIdService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LibAssignMultipleJobIdService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1.HttpClient }]; }, null); })();

function LibAssignMultipleJobIdComponent_option_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "option", 13);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const data_r1 = ctx.$implicit;
    i0.ɵɵproperty("value", data_r1.id);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate2(" ", data_r1.id, " - ", data_r1.description, " ");
} }
class LibAssignMultipleJobIdComponent {
    constructor(assignMultipleJobIdService, cdr, fb) {
        this.assignMultipleJobIdService = assignMultipleJobIdService;
        this.cdr = cdr;
        this.fb = fb;
        this.observableSubscription$ = new Subject();
        this.jobIdLists = [];
        this.getProfileCount = [];
        this.getJobDetails = [];
        this.group = new FormGroup({});
    }
    ngOnInit() {
        this.multipleAssignIdForm = this.fb.group({
            jobId: [null, Validators.nullValidator]
        });
        this.group.addControl(this.inputParams.name, this.multipleAssignIdForm);
        this.getJobList();
    }
    getJobList() {
        this.getProfileCount = JSON.parse(sessionStorage.getItem("selectedRowIds"));
        this.assignMultipleJobIdService
            .getJobIdList()
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe((response) => {
            if (response) {
                this.jobIdLists = response === null || response === void 0 ? void 0 : response.data;
            }
        });
        this.group.controls[this.inputParams.name].setValue({
            jobId: ""
        });
        this.cdr.detectChanges();
    }
    onJobIdChange(data) {
        this.assignMultipleJobIdService
            .getDetails(data.target.value)
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe((response) => {
            if (response) {
                this.getJobDetails = response === null || response === void 0 ? void 0 : response.data;
                this.group.controls[this.inputParams.name].patchValue({
                    jobId: data.target.value
                });
            }
        });
    }
}
LibAssignMultipleJobIdComponent.ɵfac = function LibAssignMultipleJobIdComponent_Factory(t) { return new (t || LibAssignMultipleJobIdComponent)(i0.ɵɵdirectiveInject(LibAssignMultipleJobIdService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i2.FormBuilder)); };
LibAssignMultipleJobIdComponent.ɵcmp = i0.ɵɵdefineComponent({ type: LibAssignMultipleJobIdComponent, selectors: [["lib-assign-multiple-job-id"]], inputs: { inputParams: "inputParams", group: "group", formControlName: "formControlName" }, decls: 31, vars: 7, consts: [[1, "row", "assign_multiple_job", 3, "formGroup"], [1, "col-12", 3, "formGroupName"], [1, "row"], [1, "col-12", "mb-4", "pb-4", "pl-0", "pt-3"], [1, "col-12", "pl-0"], [1, "row", "mb-3"], [1, "col-4", "pl-0"], [1, "label-cls"], ["formControlName", "jobId", "name", "jobId", "required", "", 1, "form-control", 3, "change"], [3, "value", 4, "ngFor", "ngForOf"], [1, "row", "separation_border"], [1, "header"], [1, "content", "p-0"], [3, "value"]], template: function LibAssignMultipleJobIdComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵelementStart(3, "h4", 3);
        i0.ɵɵtext(4, "Assign Job ID");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(5, "p", 4);
        i0.ɵɵtext(6, "Assign Job ID for ");
        i0.ɵɵelementStart(7, "strong");
        i0.ɵɵtext(8);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(9, "div", 5);
        i0.ɵɵelementStart(10, "div", 6);
        i0.ɵɵelementStart(11, "p", 7);
        i0.ɵɵtext(12, "Select Job ID/Code");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(13, "select", 8);
        i0.ɵɵlistener("change", function LibAssignMultipleJobIdComponent_Template_select_change_13_listener($event) { return ctx.onJobIdChange($event); });
        i0.ɵɵtemplate(14, LibAssignMultipleJobIdComponent_option_14_Template, 2, 3, "option", 9);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(15, "div", 10);
        i0.ɵɵelementStart(16, "div", 6);
        i0.ɵɵelementStart(17, "p", 11);
        i0.ɵɵtext(18, "Job Position");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(19, "p", 12);
        i0.ɵɵtext(20);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(21, "div", 6);
        i0.ɵɵelementStart(22, "p", 11);
        i0.ɵɵtext(23, "Location");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(24, "p", 12);
        i0.ɵɵtext(25);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(26, "div", 6);
        i0.ɵɵelementStart(27, "p", 11);
        i0.ɵɵtext(28, "Created On");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(29, "p", 12);
        i0.ɵɵtext(30);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("formGroup", ctx.multipleAssignIdForm);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("formGroupName", ctx.formControlName);
        i0.ɵɵadvance(7);
        i0.ɵɵtextInterpolate1("", ctx.getProfileCount.length, " selected Profiles");
        i0.ɵɵadvance(6);
        i0.ɵɵproperty("ngForOf", ctx.jobIdLists);
        i0.ɵɵadvance(6);
        i0.ɵɵtextInterpolate((ctx.getJobDetails == null ? null : ctx.getJobDetails.jobPosition == null ? null : ctx.getJobDetails.jobPosition.name) || "--");
        i0.ɵɵadvance(5);
        i0.ɵɵtextInterpolate((ctx.getJobDetails == null ? null : ctx.getJobDetails.stateProvinceName) || "--");
        i0.ɵɵadvance(5);
        i0.ɵɵtextInterpolate((ctx.getJobDetails == null ? null : ctx.getJobDetails.date) || "--");
    } }, directives: [i2.NgControlStatusGroup, i2.FormGroupDirective, i2.FormGroupName, i2.SelectControlValueAccessor, i2.NgControlStatus, i2.FormControlName, i2.RequiredValidator, i3.NgForOf, i2.NgSelectOption, i2.ɵangular_packages_forms_forms_z], styles: [".assign_multiple_job[_ngcontent-%COMP%]   h4[_ngcontent-%COMP%]{font-weight:600;border-bottom:1px solid #333}.assign_multiple_job[_ngcontent-%COMP%]   .header[_ngcontent-%COMP%]{font-size:14px;margin-bottom:10px}.assign_multiple_job[_ngcontent-%COMP%]   .content[_ngcontent-%COMP%]{font-weight:600}.assign_multiple_job[_ngcontent-%COMP%]   .separation_border[_ngcontent-%COMP%]{border-bottom:1px dashed #ccc}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LibAssignMultipleJobIdComponent, [{
        type: Component,
        args: [{
                selector: 'lib-assign-multiple-job-id',
                templateUrl: "./lib-assign-multiple-job-id.component.html",
                styleUrls: ["./lib-assign-multiple-job-id.component.scss"],
            }]
    }], function () { return [{ type: LibAssignMultipleJobIdService }, { type: i0.ChangeDetectorRef }, { type: i2.FormBuilder }]; }, { inputParams: [{
            type: Input
        }], group: [{
            type: Input
        }], formControlName: [{
            type: Input
        }] }); })();

class LibAssignMultipleJobIdModule {
}
LibAssignMultipleJobIdModule.ɵfac = function LibAssignMultipleJobIdModule_Factory(t) { return new (t || LibAssignMultipleJobIdModule)(); };
LibAssignMultipleJobIdModule.ɵmod = i0.ɵɵdefineNgModule({ type: LibAssignMultipleJobIdModule });
LibAssignMultipleJobIdModule.ɵinj = i0.ɵɵdefineInjector({ imports: [[
            PrimengLibraryModule,
            FormsModule,
            ReactiveFormsModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(LibAssignMultipleJobIdModule, { declarations: [LibAssignMultipleJobIdComponent], imports: [PrimengLibraryModule,
        FormsModule,
        ReactiveFormsModule], exports: [LibAssignMultipleJobIdComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LibAssignMultipleJobIdModule, [{
        type: NgModule,
        args: [{
                declarations: [LibAssignMultipleJobIdComponent],
                imports: [
                    PrimengLibraryModule,
                    FormsModule,
                    ReactiveFormsModule
                ],
                exports: [LibAssignMultipleJobIdComponent]
            }]
    }], null, null); })();

/*
 * Public API Surface of lib-assign-multiple-job-id
 */

/**
 * Generated bundle index. Do not edit.
 */

export { LibAssignMultipleJobIdComponent, LibAssignMultipleJobIdModule, LibAssignMultipleJobIdService };
//# sourceMappingURL=lib-assign-multiple-job-id.js.map
